import React, { useEffect } from 'react'
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom'
import { MainLayout } from '../components/layout/MainLayout'
import { AlwaysAlert } from '../pages/AlwaysAlert'
import { BaseRegister } from '../pages/BaseRegister'
import { Contact } from '../pages/Contact'
import { Employees } from '../pages/Employees'
import { Home } from '../pages/Home'
import { Login } from '../pages/Login'
import { OnlineEmployees } from '../pages/OnlineEmployees'
import { PageNotFound } from '../pages/PageNotFound'
import { RecoverPassword } from '../pages/RecoverPassword'
import { Residents } from '../pages/Residents'
import { ResidentsContracts } from '../pages/ResidentsContracts'
import { SecurityCamera } from '../pages/SecurityCamera'
import { Welcome } from '../pages/Welcome'

import { LatestRequests } from '../pages/LatestRequests'

import AlwaysAlertProvider from '../context/context_alwaysAlert'
import ContextBaseProvider from '../context/context_baseRegister'
import ContextContractsProvider from '../context/context_contracts'

import ContextProvider from '../context/context_employee'
import ContextLatestRequestsProvider from '../context/context_latestRequests'
import ContextResidentsProvider from '../context/context_residents'

function ProtectedRoute({ children }) {
  const navigate = useNavigate()

  useEffect(() => {
    const token = localStorage.getItem('token')

    if (!token) {
      console.log('Redirecting to /login')
      navigate('/login')
    }
  }, [navigate])

  return <>{children}</>
}

export function AuthRoutes() {
  return (
    <Routes>
      {/* Redirect unauthRoutes */}
      <Route path="/" element={<Navigate to="/home" />} />
      <Route path="/login" element={<Navigate to="/home" />} />
      <Route path="/recuperar/senha" element={<Navigate to="/home" />} />
      <Route path="/contato" element={<Navigate to="/home" />} />

      <Route element={<MainLayout />}>
        <Route
          path="/home"
          element={
            <ContextProvider>
              <Home />
            </ContextProvider>
          }
        />
        {/* Rotas Functionarios */}
        <Route
          path="/funcionarios"
          element={
            <ContextProvider>
              <Employees />
            </ContextProvider>
          }
        />
        <Route
          path="/funcionarios/base/cadastro"
          element={
            <ContextBaseProvider>
              <BaseRegister />
            </ContextBaseProvider>
          }
        />
        {/* Rotas Moradores */}
        <Route
          path="/moradores"
          element={
            <ContextResidentsProvider>
              <Residents />
            </ContextResidentsProvider>
          }
        />
        <Route
          path="/moradores/contratos"
          element={
            <ContextContractsProvider>
              <ResidentsContracts />
            </ContextContractsProvider>
          }
        />
        {/* Rotas vigilancia */}
        <Route
          path="/vigilancia/funcionarios/online"
          element={<OnlineEmployees />}
        />
        <Route
          path="/vigilancia/sempre-alerta"
          element={
            <AlwaysAlertProvider>
              <AlwaysAlert />
            </AlwaysAlertProvider>
          }
        />
        <Route
          path="/vigilancia/ultimas-ocorrencias"
          element={
            <ContextLatestRequestsProvider>
              <LatestRequests />
            </ContextLatestRequestsProvider>
          }
        />
        <Route
          path="/vigilancia/cameras/seguranca"
          element={<SecurityCamera />}
        />
      </Route>
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  )
}
